// Verbatim legal content from master doc §12.4 – §12.11

export const legalPages = {
  privacy: {
    title: "Privacy Policy",
    effective: "Effective date: 16 April 2026 · Last updated: 16 April 2026",
    body: `Hubinall is a product brand by Erenown. This website is proposed to be operated primarily by Erenown LLC, a company registered in the Republic of Kosovo. In certain commercial or operational contexts, specific services may instead be provided by Erenown Ltd, a company registered in England and Wales, where that is expressly stated in the relevant communication, proposal, engagement letter, or contract. Erenown Ltd and Erenown LLC are separate, independent companies under the same ultimate beneficial ownership and control. Nothing in this Privacy Policy should be read as implying that one company is a branch or subsidiary of the other unless expressly stated elsewhere in a signed legal instrument.

1. Who controls personal data?
For general website operation, inquiries, and inbound lead handling, the primary data controller is proposed to be:
• Erenown LLC, Bulevardi Dëshmorët e Kombit, C2, HIII, Nr.6, Prishtinë, Republic of Kosovo.
• Registration number / unique identification number: 811869512.
Where a request is handled directly by the UK company, or where a service, agreement, or follow-up is explicitly transferred to the UK company, the relevant controller may instead be:
• Erenown Ltd, 83 St. Marks Road, Enfield, England, EN1 1BJ, United Kingdom.
• Company number: 12845592.
General contact email for privacy and website matters: hi@hubinall.com.

2. What information do we collect
• identity and contact details such as full name, company name, country, email address, phone number, and WhatsApp number;
• business inquiry details such as service interest, setup plans, workflow needs, software or integration interest, and institutional collaboration interest;
• message content, attachments, technical inquiry details, and any information you choose to submit;
• website usage data such as browser type, device information, IP-related technical logs, cookie preferences, and analytics data where enabled.

3. How we collect information
• when you complete a website form;
• when you request a call or contact us by email, phone, or WhatsApp;
• when you communicate with us about services, partnerships, integrations, or business opportunities;
• through cookies and similar technologies, subject to your preferences where required.

4. Why do we use personal data
• to respond to inquiries and assess whether Hubinall or Erenown can assist you;
• to arrange calls, follow-up communications, proposals, and onboarding discussions;
• to manage inbound leads, partnership discussions, and institutional contacts;
• to improve website performance, security, usability, and conversion pathways;
• to keep business records and maintain communication history;
• to send relevant updates where permitted by law or where you have opted in.

5. Legal bases
• pre-contractual steps, where you ask us to discuss or assess a possible service;
• legitimate interests, for the structured operation, improvement, and protection of our website and communications;
• consent, where this is required for non-essential cookies or optional marketing communications;
• legal obligations, where retention or disclosure is required by applicable law.

6. Sharing of data
Personal data may be shared on a need-to-know basis with website hosting providers, analytics providers, email and CRM tools, professional advisers, and selected partners where relevant to your request. Data may also be shared between Erenown LLC and Erenown Ltd, where necessary to assess, route, or perform a specific business opportunity, provided that the receiving company is clearly identified when appropriate. We do not sell personal data.

7. International transfers
Because Hubinall is intended to support coordination across Kosovo, Türkiye, the United Kingdom, and other cross-border business contexts, personal data may be accessed or processed across more than one jurisdiction. Where that occurs, we aim to apply appropriate contractual, organisational, and technical safeguards proportionate to the circumstances.

8. Retention
We keep personal data only for as long as reasonably necessary to respond to your request, maintain business records, manage follow-up communications, comply with legal obligations, resolve disputes, and protect legitimate business interests.

9. Your rights
• access your personal data;
• request correction or update of inaccurate data;
• request deletion where retention is no longer necessary;
• object to certain processing;
• withdraw consent where consent is the legal basis;
• ask for restriction or portability where applicable;
• opt out of marketing communications at any time.
To exercise a privacy right, contact hi@hubinall.com.

10. Cookies
Please read the Hubinall Cookie Policy and use the site cookie preference controls for more information.

11. Security
We apply reasonable technical and organisational safeguards to protect personal data. However, no website, communication channel, or storage system can be guaranteed to be completely secure.

12. Third-party websites
Where our website links to third-party partners, public authorities, or external information sources, their privacy practices are governed by their own policies and notices.

13. Change of operating entity or transfer of website operations
Website operations, records, communications, and related rights and obligations may in the future be transferred, assigned, or novated to Erenown Ltd or to another company under the same ultimate beneficial ownership and control, where commercially appropriate and legally permitted. If that occurs, this Privacy Policy will be updated, and the relevant operating entity will be clearly identified.

14. Contact
For privacy questions or complaints, contact: hi@hubinall.com.`,
  },
  cookies: {
    title: "Cookie Policy",
    effective: "Effective date: 16 April 2026 · Last updated: 16 April 2026",
    body: `This Cookie Policy explains how Hubinall, a product brand by Erenown, uses cookies and similar technologies on its website.

1. What cookies are
Cookies are small text files stored on your device by websites you visit. They help websites function, remember preferences, measure usage, and improve user experience.

2. Types of cookies we may use
• Strictly necessary cookies — used to operate core site functions, security controls, and essential form or session behavior.
• Analytics cookies — used to understand how visitors interact with the site and how the site can be improved.
• Preference cookies — used to remember settings such as language or consent choices.
• Marketing cookies — used only where such tools are actually enabled and only where consent is obtained if required.

3. Legal basis
Strictly necessary cookies may be used based on legitimate interests in running the website. Non-essential cookies should only be activated in line with the visitor’s consent preferences, where applicable law requires that.

4. How to manage cookies
Visitors should be able to accept all cookies, reject non-essential cookies, or manage preferences through the cookie banner and preference center. Visitors may also manage cookies through their browser settings.

5. Third-party technologies
Some cookies may be set by analytics tools, embedded content providers, form tools, chat tools, map tools, or other service providers used on the website.

6. Updates
This Cookie Policy may be updated from time to time to reflect changes in law, technology, or site functionality.

7. Contact
For questions about cookies or consent preferences, contact hi@hubinall.com.`,
  },
  terms: {
    title: "Terms of Use",
    effective: "Effective date: 16 April 2026 · Last updated: 16 April 2026",
    body: `These Terms of Use govern the use of the Hubinall website. Hubinall is a product brand by Erenown.

1. Website purpose
This website presents information about Hubinall’s services, solutions, platform direction, resources, legal notices, and ecosystem model.

2. No professional advice
Website content is provided for general information only. It does not constitute legal, tax, accounting, regulatory, investment, or other professional advice.

3. No guarantee of results
Descriptions of setup support, software enablement, integrations, workflow solutions, partner pathways, or institutional discussions are indicative only. Actual outcomes depend on the facts, the applicable jurisdiction, partner availability, regulatory requirements, technical readiness, and separate agreements.

4. Intellectual property
Unless otherwise stated, website content, structure, copy, design elements, and original materials are owned by or licensed to the relevant Erenown company. Third-party names, logos, or marks remain the property of their respective owners.

5. Third-party references
References to partners, institutions, products, software providers, and official resources do not mean that all services are available in all cases or that any particular outcome is guaranteed.

6. Acceptable use
You must not misuse the site, interfere with its operation, attempt unauthorised access, upload malicious material, or use the site for unlawful purposes.

7. Limitation of liability
To the fullest extent permitted by law, the relevant Erenown company disclaims liability for indirect, incidental, special, or consequential loss arising out of website use. Nothing in these Terms excludes liability that cannot lawfully be excluded.

8. No contract formed by website use alone
Use of the website, a form submission, or a general inquiry does not by itself create a binding service contract. Any engagement is subject to a separate proposal, statement of work, engagement letter, or other signed agreement.

9. Changes to the website and these terms
We may update or discontinue content, links, service descriptions, or these Terms of Use from time to time.

10. Governing framework
These Terms apply to website use only. Service-specific governing law, jurisdiction, and entity identity should be stated in the relevant commercial agreement or legal notice.`,
  },
  disclaimer: {
    title: "Disclaimer",
    effective: "Effective date: 16 April 2026 · Last updated: 16 April 2026",
    body: `Hubinall is a product brand by Erenown. This website is intended to present structured information about business setup coordination, professional workflows, software enablement, document flows, integrations, and related ecosystem pathways. Nothing on this website should be interpreted as legal advice, tax advice, accounting advice, regulatory assurance, financial advice, investment advice, or a guarantee of registration, approval, licensing, integration, financing, or business success. Any partner pathway, institutional discussion, product description, or setup route described on the website remains subject to separate review, jurisdiction-specific requirements, partner availability, and separate agreement where applicable.`,
  },
  company: {
    title: "Company Information / Legal Notice",
    effective: "",
    body: `Brand: Hubinall is a product brand by Erenown.

Primary website operator:
Erenown LLC
Bulevardi Dëshmorët e Kombit, C2, HIII, Nr.6
Prishtinë, Republic of Kosovo
Registration number: 811869512

Separate UK company under same ultimate beneficial ownership and control:
Erenown Ltd
83 St. Marks Road, Enfield, England, EN1 1BJ
United Kingdom
Company number: 12845592

General contact: hi@hubinall.com

Status note: Erenown Ltd and Erenown LLC are separate companies. Publication of both entities on this website does not mean that one is a branch, subsidiary, or office of the other unless expressly stated in a specific contract or legal instrument.

Operating note: Depending on geography, service scope, and contract allocation, a specific service may be offered by Erenown LLC, Erenown Ltd, or another company under the same ultimate beneficial ownership and control, provided the contracting entity is clearly identified.`,
  },
  security: {
    title: "Security / Responsible Disclosure",
    effective: "",
    body: `If you believe you have identified a security issue affecting the Hubinall website, please contact hi@hubinall.com with relevant details.

• do not exploit a vulnerability;
• do not access data without authorisation;
• do not disrupt services or impair availability;
• do not conduct harmful or unlawful testing.

Good-faith, responsible disclosure is appreciated.`,
  },
  accessibility: {
    title: "Accessibility Statement",
    effective: "",
    body: `Hubinall aims to make its website readable, navigable, and usable for a broad range of visitors. We intend to improve content structure, responsive layout, form usability, and overall clarity over time. If you encounter an accessibility issue, please contact hi@hubinall.com.`,
  },
  "partner-disclosure": {
    title: "Partner and Referral Disclosure",
    effective: "",
    body: `Hubinall operates through an ecosystem model and may refer inquiries to selected partners, advisers, software providers, or other ecosystem participants where relevant. In some cases, the relevant Erenown company may receive a referral fee, coordination fee, commission, or other commercial benefit from partner-related work. Visitors and clients should independently assess any third-party provider before entering a separate engagement. Any third-party service remains subject to that provider’s own terms, pricing, scope, and compliance requirements.`,
  },
};
